var ScrollTo = {}

ScrollTo.install = function (Vue) {
  var service = {}

  var scrollInfo = {
    startOffset: 0,
    targetOffset: 0,
    currentOffset: 0
  }

  var elapsedTime = 0
  var startTime = 0
  var isUpdating = false
  var scrollSpeed = 500
  var scrollOffset = 0
  var scrollElement = null

  service.isScrolling = false

  service.go = function (elementId, speed, offset) {
    cancelUpdate()

    scrollElement = document.getElementById(elementId)
    if (!scrollElement) {
      return
    }

    if (speed) {
      scrollSpeed = speed
    }
    if (offset) {
      scrollOffset = offset
    }

    var coords = Vue.$utils.getCoords(scrollElement)

    if (!coords) {
      return
    }

    scrollInfo.currentOffset = coords.scrollTop
    scrollInfo.startOffset = coords.scrollTop
    scrollInfo.targetOffset = coords.top - scrollOffset

    initUpdate()
  }

  function update () {
    if (!scrollElement) {
      return
    }

    elapsedTime = (Date.now() - startTime)

    if (elapsedTime < scrollSpeed) {
      scrollInfo.currentOffset = Math.round(
        Vue.$utils.lerp(
          scrollInfo.startOffset,
          scrollInfo.targetOffset,
          Vue.$easing.easeInOutQuad(elapsedTime / scrollSpeed)
        )
      )
    } else {
      scrollInfo.currentOffset = scrollInfo.targetOffset
      cancelUpdate()
    }

    window.scrollTo(0, scrollInfo.currentOffset)

    if (isUpdating) {
      requestAnimationFrame(update)
    }
  }

  function initUpdate () {
    service.isScrolling = isUpdating = true
    startTime = Date.now()
    update()
  }

  function cancelUpdate () {
    service.isScrolling = isUpdating = false
    startTime = 0
    elapsedTime = 0
  }

  Vue.$scrollTo = service
}

export default ScrollTo



// WEBPACK FOOTER //
// ./src/plugins/ScrollTo.js